<template>
  <el-input
    ref="inputRef"
    v-model="displayValue"
    v-bind="$attrs"
    @input="handleInput"
    @blur="handleBlur"
  >
    <template v-if="is_unit" #append>{{ unit }}</template></el-input
  >
</template>

<script setup>
import { ref, watch, computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: [Number, String],
  precision: {
    type: Number,
    default: 0,
    validator: val => val >= 0
  },
  min: Number,
  max: Number,
  unit: {
    type: String,
    default: ""
  },
  is_unit: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(["update:modelValue"]);

const inputRef = ref(null);
const displayValue = ref(formatNumber(props.modelValue));

// 监听外部值变化
watch(
  () => props.modelValue,
  newVal => {
    displayValue.value = formatNumber(newVal);
  }
);

// 格式化数字（核心方法）
function formatNumber(value) {
  if (value === null || value === undefined || value === "") return "";

  let num = parseFloat(value);
  if (isNaN(num)) return "";

  // 处理范围限制
  if (props.min !== undefined && num < props.min) num = props.min;
  if (props.max !== undefined && num > props.max) num = props.max;
  return num;
}

// 输入处理
function handleInput(val) {
  // 过滤非法字符（保留数字和小数点）
  let filtered = val.replace(/[^\d.]/g, "");

  // 处理多个小数点的情况
  const decimalCount = filtered.split(".").length - 1;
  if (decimalCount > 1) {
    filtered = filtered.slice(0, filtered.lastIndexOf("."));
  }

  // 处理开头的小数点
  if (filtered.startsWith(".")) {
    filtered = "0" + filtered;
  }

  // 处理小数位限制
  const parts = filtered.split(".");
  if (parts.length > 1) {
    filtered = `${parts[0]}.${parts[1].slice(0, props.precision)}`;
  }

  displayValue.value = filtered;
  emitNumberValue(filtered);
}

// 失焦时格式化
function handleBlur() {
  displayValue.value = formatNumber(displayValue.value);
  emitNumberValue(displayValue.value);
}

// 向父组件发射数值
function emitNumberValue(val) {
  const num = parseFloat(val);
  emit("update:modelValue", isNaN(num) ? null : num);
}
</script>
